import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { Link } from "react-router-dom";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const makeIcon = (premium) =>
  L.divIcon({
    className: "",
    html: `<div style="width:30px;height:38px;position:relative;">
      <div style="width:30px;height:30px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:${premium ? "#FF9F1C" : "#0E3F5B"};box-shadow:0 2px 6px rgba(0,0,0,.3);"></div>
      <div style="position:absolute;top:8px;left:9px;width:12px;height:12px;border-radius:50%;background:#fff;"></div>
    </div>`,
    iconSize: [30, 38],
    iconAnchor: [15, 38],
    popupAnchor: [0, -34],
  });

export const MapView = ({ trucks = [], height = 460, center }) => {
  const pts = trucks.filter((t) => t.lat != null && t.lng != null);
  const c = center || (pts.length ? [pts[0].lat, pts[0].lng] : [46.6, 2.4]);
  const zoom = center ? 13 : pts.length ? 6 : 5;

  return (
    <div style={{ height }} className="rounded-2xl overflow-hidden shadow-warm" data-testid="map-view">
      <MapContainer center={c} zoom={zoom} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {pts.map((t) => (
          <Marker key={t.slug} position={[t.lat, t.lng]} icon={makeIcon(t.plan === "pro" || t.plan === "proplus")}>
            <Popup>
              <div style={{ minWidth: 150 }}>
                <div style={{ fontWeight: 700, color: "#0E3F5B" }}>{t.name}</div>
                <div style={{ fontSize: 12, color: "#666" }}>{t.cuisine} · {t.city}</div>
                <Link to={`/foodtruck/${t.slug}`} style={{ color: "#FF9F1C", fontWeight: 700, fontSize: 13 }}>Voir la fiche →</Link>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};
